import { render, staticRenderFns } from "./ScreenCombos.vue?vue&type=template&id=7790ae5b&scoped=true"
import script from "./ScreenCombos.vue?vue&type=script&lang=js"
export * from "./ScreenCombos.vue?vue&type=script&lang=js"
import style0 from "./ScreenCombos.vue?vue&type=style&index=0&id=7790ae5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7790ae5b",
  null
  
)

export default component.exports